"use strict";

var _regeneratorRuntime = require("/builds/Cimpress-Technology/ff/apps/ContractManagerV2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _serviceHelpers = require("./serviceHelpers");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchWithAuth =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$method, method, route, body, _ref$additionalHeader, additionalHeaders, _ref$giveSimpleRespon, giveSimpleResponse, accessToken, options, baseUrl, fullUrl, rawResponse, parsedResponse;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$method = _ref.method, method = _ref$method === void 0 ? 'GET' : _ref$method, route = _ref.route, body = _ref.body, _ref$additionalHeader = _ref.additionalHeaders, additionalHeaders = _ref$additionalHeader === void 0 ? {} : _ref$additionalHeader, _ref$giveSimpleRespon = _ref.giveSimpleResponse, giveSimpleResponse = _ref$giveSimpleRespon === void 0 ? true : _ref$giveSimpleRespon, accessToken = _ref.accessToken;
            options = (0, _serviceHelpers.buildOptions)(method, body, additionalHeaders, accessToken);
            baseUrl = 'https://api.products.cimpress.io';
            fullUrl = "".concat(baseUrl, "/").concat(route);
            _context.prev = 4;
            _context.next = 7;
            return fetch(fullUrl, options);

          case 7:
            rawResponse = _context.sent;
            _context.next = 10;
            return (0, _serviceHelpers.checkResponse)(rawResponse, "".concat(method, " ").concat(fullUrl), giveSimpleResponse);

          case 10:
            parsedResponse = _context.sent;
            return _context.abrupt("return", parsedResponse);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](4);

            if (process.env.NODE_ENV !== 'test') {
              console.error(_context.t0);
            }

            throw _context.t0;

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 14]]);
  }));

  return function fetchWithAuth(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = fetchWithAuth;
exports["default"] = _default;